import { createAction } from "@ngrx/store";

import { AddressByCepResponse } from "./registration-with-cep.model";

export const ACTION_PREFIX = "[Registration With CEP]";
export const REGISTRATION_WITH_CEP_ACTION_TYPE = {
	getAddressByCep: `${ACTION_PREFIX} Get Address by CEP`,
	getAddressByCepSuccess: `${ACTION_PREFIX} Get Address by CEP Success`,
	getAddressByCepFail: `${ACTION_PREFIX} Get Address by CEP Fail`,

	getCepPersonalDataSuccess: `${ACTION_PREFIX} Get CEP Success`,

	cepValueCheckFail: `${ACTION_PREFIX} CEP value check Fail`,
};

export namespace RegistrationWithCepAction {
	export const getAddressByCep = createAction(REGISTRATION_WITH_CEP_ACTION_TYPE.getAddressByCep, (cep: string) => ({
		cep,
	}));

	export const getAddressByCepSuccess = createAction(
		REGISTRATION_WITH_CEP_ACTION_TYPE.getAddressByCepSuccess,
		(response: AddressByCepResponse) => ({ response })
	);

	export const getAddressByCepFail = createAction(
		REGISTRATION_WITH_CEP_ACTION_TYPE.getAddressByCepFail,
		(error: any) => ({
			error,
		})
	);

	export const cepValueCheckFail = createAction(REGISTRATION_WITH_CEP_ACTION_TYPE.cepValueCheckFail);
	export const getCepPersonalDataSuccess = createAction(REGISTRATION_WITH_CEP_ACTION_TYPE.getCepPersonalDataSuccess);
}
